import { render, staticRenderFns } from "./CampaignsTable.vue?vue&type=template&id=0b36e028"
import script from "./CampaignsTable.vue?vue&type=script&lang=js"
export * from "./CampaignsTable.vue?vue&type=script&lang=js"
import style0 from "./CampaignsTable.vue?vue&type=style&index=0&id=0b36e028&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports